import { DlpProductTradeId } from 'epic/blotters/commonBlotterEpics';
import type { BlotterType } from 'models/blotters/BlotterType';
import type { IBlotterItem } from 'models/IBlotterItem';
import { getBlotterType } from 'state/selectors/common/misc';
import type { Thunk } from 'state/state.common';

import {
  blotterPanelItemDetailsRequested,
  blotterPanelItemDetailsSecondarySelected,
  blotterPanelItemDetailsSelected,
  blotterPanelItemReset,
  blotterPanelPriceImprovementActionsAdded,
} from './blotterPanel.action';

export function blotterPanelItemDetailsRequestedThunk<T extends IBlotterItem = IBlotterItem>(
  idSelector: (item?: T) => DlpProductTradeId | undefined | string,
  item?: T,
): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const blotterType = getBlotterType(state, item);
    const selectedItemId = state.blotters.blotterPanel.id;
    const itemId = idSelector(item);
    let isSameId = selectedItemId === itemId;
    if (blotterType === 'dlpProductTrades') {
      const panelId = selectedItemId as DlpProductTradeId | undefined;
      const id = itemId as DlpProductTradeId | undefined;
      isSameId = panelId?.productIsin === id?.productIsin && panelId?.tradeReference === id?.tradeReference;
    }
    if (isSameId || !item || !itemId) {
      dispatch(blotterPanelItemReset());
      return;
    }
    if (blotterType !== 'priceNegotiations') {
      dispatch(blotterPanelItemDetailsRequested<T>(itemId, blotterType, item));
    } else {
      dispatch(blotterPanelPriceImprovementActionsAdded(item));
    }
  };
}

export function blotterPanelItemDetailsClickedThunk(blotterType: BlotterType, id?: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const selectedItem = state.blotters.blotterPanel.selected;
    if (selectedItem?.id === id || !id) {
      dispatch(blotterPanelItemReset());
    } else {
      dispatch(blotterPanelItemDetailsSelected(id, blotterType));
    }
  };
}

export function blotterPanelItemDetailsSecondaryClickedThunk(quoteId?: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const selectedItem = state.blotters.blotterPanel.selected;
    if (selectedItem?.id === quoteId || !quoteId) {
      dispatch(blotterPanelItemReset());
    } else {
      dispatch(blotterPanelItemDetailsSecondarySelected(quoteId));
    }
  };
}
